import { actionCreator } from 'utils';
import * as PartnerTypes from '../types/partnerTypes';

// L O A D   P A R T N E R S
export function loadPartners() {
    return {
        type: PartnerTypes.LOAD_PARTNERS,
    };
}

export function loadPartnersRes(data) {
    return {
        type: actionCreator(PartnerTypes.LOAD_PARTNERS, 'res'),
        data,
    };
}

export function loadPartnersErr() {
    return {
        type: actionCreator(PartnerTypes.LOAD_PARTNERS, 'err'),
    };
}
// L O A D   P A R T N E R S

// S E T   P A R T N E R S   F I L T E R
export function setPartnerFilters(key, value) {
    return {
        type: PartnerTypes.SET_PARTNER_FILTER,
        key,
        value,
    };
}

export function setPartnerPagination(key, pagination) {
    return {
        type: PartnerTypes.SET_PARTNER_PAGINATION,
        key,
        pagination,
    };
}

export function setPartnerSort(key, type) {
    return {
        type: PartnerTypes.SET_PARTNER_SORT,
        sort: {
            key,
            type,
        },
    };
}
// S E T   P A R T N E R S   F I L T E R


// A D D   N E W   P A R T N E R S
export function addNewPartner(data) {
    return {
        type: PartnerTypes.ADD_NEW_PARTNER,
        data,
    };
}

export function addNewPartnerRes(loading, success) {
    return {
        type: actionCreator(PartnerTypes.ADD_NEW_PARTNER, 'res'),
        loading,
        success,
    };
}

export function addNewPartnerErr(error) {
    return {
        type: actionCreator(PartnerTypes.ADD_NEW_PARTNER, 'err'),
        error,
    };
}
// A D D   N E W   P A R T N E R S


// E D I T   P A R T N E R S
export function editPartner(data) {
    return {
        type: PartnerTypes.EDIT_PARTNER,
        data,
    };
}

export function editPartnerRes(loading, success) {
    return {
        type: actionCreator(PartnerTypes.EDIT_PARTNER, 'res'),
        loading,
        success,
    };
}

export function editPartnerErr() {
    return {
        type: actionCreator(PartnerTypes.EDIT_PARTNER, 'err'),
    };
}
// E D I T   P A R T N E R S


// L O A D   E D I T A B L E   P A R T N E R S
export function loadEditablePartner(id) {
    return {
        type: PartnerTypes.LOAD_EDITABLE_PARTNER,
        id,
    };
}

export function loadEditablePartnerRes(data) {
    return {
        type: actionCreator(PartnerTypes.LOAD_EDITABLE_PARTNER, 'res'),
        data,
    };
}

export function loadEditablePartnerErr() {
    return {
        type: actionCreator(PartnerTypes.LOAD_EDITABLE_PARTNER, 'err'),
    };
}

export function setEmptyEditablePartner() {
    return {
        type: PartnerTypes.SET_EMPTY_EDITABLE_PARTNER,
    };
}
// L O A D   E D I T A B L E   P A R T N E R S
